/** AES-256-ECB Base64 key for BFSL trading mall Invest Now redirect */
export const BFSL_TRADING_MALL_AES_KEY = process.env.NEXT_PUBLIC_BFSL_TRADING_MALL_AES_KEY ?? "";

export const BFSL_TRADING_MALL_BASE_URL =
  "https://bfsltrade.bajajfinservsecurities.in/tradingmall/";

/** Hardcoded params in Invest Now encrypted payload */
export const BFSL_INVEST_NOW_SCREEN = "mforderpadScreen";
export const BFSL_INVEST_NOW_TYPE = "new";
